import { Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto } from '../../services/wealthlane-identity-services/models/Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto';
import { TwoFactorPurposeService } from '../../services/wealthlane-identity-services/services/TwoFactorPurposeService';
import { type UseQueryResult, useQuery } from 'react-query';


const useGetTwoFactorPurposes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Array<Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto> | undefined, unknown> => {
  return useQuery(['getTwoFactorPurposes'], async () => {
    return await handleRequest(
      TwoFactorPurposeService.getApiIdentityApiAppTwoFactorPurpose()
    );
  });
};

export default useGetTwoFactorPurposes;
